import { render, staticRenderFns } from "./SelectionTable.vue?vue&type=template&id=087dc5d7&scoped=true"
import script from "./SelectionTable.vue?vue&type=script&lang=ts"
export * from "./SelectionTable.vue?vue&type=script&lang=ts"
import style0 from "./SelectionTable.vue?vue&type=style&index=0&id=087dc5d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087dc5d7",
  null
  
)

export default component.exports